module.exports = __webpack_public_path__ + "img/05.ab96197c.png";